import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const Microphone = ({ title, titleId, desc, descId }: SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 96 96"
    aria-labelledby={titleId}
    aria-describedby={descId}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#CFCFCF"
      d="M55.8 69.2c-2.4.9-5.1 1.3-7.8 1.3s-5.4-.5-7.8-1.3v10.2h15.7V69.2z"
    />
    <path fill="#3F3F3F" d="M55.8 79.3H16.7V95h62.6V79.3z" />
    <path
      fill="#CFCFCF"
      d="M48 24.5H24.5V48h47V24.5C71.5 11.6 61 1 48 1 37.8 1 29.1 7.6 25.9 16.7H48zm0 13.7H24.5v-7.8H48z"
    />
    <path
      fill="#3F3F3F"
      d="M48 24.5v-7.8H25.9c-.9 2.4-1.3 5.1-1.3 7.8zM48 30.4H24.5v7.8H48z"
    />
    <path
      fill="#ED0000"
      d="M48 47.5V71c2.7 0 5.4-.5 7.8-1.3 9.1-3.2 15.7-11.9 15.7-22.1H48z"
    />
    <path
      fill="#3F3F3F"
      d="M24.5 47.5c0 10.2 6.5 18.9 15.7 22.1 2.4.9 5.1 1.3 7.8 1.3V47.5z"
    />
  </svg>
);
export default Microphone;
